import { isEmpty } from 'lodash';

import { ISnackbarInfo } from 'context/SnackbarProvider/SnackbarProvider';
import { FetchDataResponse } from 'utils/fetchData/fetchDataUtils';

const setError = (
  setSnackbarInfo: (value: ((prevState: ISnackbarInfo) => ISnackbarInfo) | ISnackbarInfo) => void,
  errorMessageHeader: string,
  errorMessageBody: string
) => {
  console.error(`${errorMessageHeader}: ${errorMessageBody}`);

  setSnackbarInfo({
    severity: 'error',
    open: true,
    content: {
      header: errorMessageHeader,
      message: 'If the issue persists please report it to our support team',
    },
  });
};

export const handleFetchResponse = async <T>(
  fetchFunction: () => Promise<FetchDataResponse<T>>,
  setSnackbarInfo: (value: ((prevState: ISnackbarInfo) => ISnackbarInfo) | ISnackbarInfo) => void,
  errorMessageHeader: string,
  handleData?: (data: T) => void,
  handleBlob?: (blob: Blob, headers: Headers) => void
) => {
  try {
    const result = await fetchFunction();
    if (result.data && !isEmpty(result.data)) {
      if (handleData) {
        handleData(result.data);
      }
    } else if (result.blob && result.headers) {
      if (handleBlob) {
        handleBlob(result.blob, result.headers);
      }
    } else if (result.errorResponse) {
      setError(setSnackbarInfo, errorMessageHeader, result.errorResponse.message);
    }
  } catch (err) {
    const error = err as Error;
    setError(setSnackbarInfo, errorMessageHeader, error.message);
  }
};
